<script setup lang="ts">
import { Ref, ref, toRefs, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import { titleInputRules } from "@/ui/validation/validationRules";
import { toastApiResult } from "@/toaster";
import { useApiClient } from "@/api/client";
import ColorPicker from "@/ui/components/colorPicker/ColorPicker.vue";
import BexLabelDO = Modules.BookingExperts.Data.BexLabelDO;
const isDialogVisible = defineModel<boolean>();
const emit = defineEmits(["refresh-labels"]);

const { t } = useI18n();

const props = withDefaults(
	defineProps<{
		bexLabel: BexLabelDO;
	}>(),
	{}
);
const { bexLabel } = toRefs(props);
const localBexLabel = ref<BexLabelDO>();

onBeforeMount(() => (localBexLabel.value = { ...bexLabel.value }));

const isFormValid: Ref<boolean> = ref(false);

const saveLabel = () => {
	if (bexLabel.value.uuid) {
		updateExistingLabel();
	} else {
		createNewLabel();
	}
};

const updateExistingLabel = async () => {
	const response = await toastApiResult(
		useApiClient("proLoyalty").updateLabel(localBexLabel.value)
	);
	if (response.isOk()) {
		emit("refresh-labels");
		isDialogVisible.value = false;
	}
};

const createNewLabel = async () => {
	const response = await toastApiResult(
		useApiClient("proLoyalty").createLabel(localBexLabel.value)
	);
	if (response.isOk()) {
		emit("refresh-labels");
		isDialogVisible.value = false;
	}
};
</script>

<template>
	<v-dialog v-model="isDialogVisible" persistent width="50vw">
		<v-form v-model="isFormValid">
			<v-card elevation="9" class="help">
				<v-toolbar style="border-radius: 0 !important" flat>
					<v-toolbar-title
						><i class="fa-duotone fa-tags fa-xl mr-3"></i>Label
					</v-toolbar-title>
					<v-spacer></v-spacer>

					<v-btn icon @click="isDialogVisible = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-divider style="border-color: unset !important" />
				<div class="mt-5">
					<div class="px-5">
						<h6 class="text-h6 mb-3">Name:</h6>
						<v-text-field
							hide-details="auto"
							:min-width="200"
							placeholder="Title name"
							v-model="localBexLabel.name"
							:rules="titleInputRules(t)"
						/>
					</div>
				</div>

				<div class="mt-5">
					<div class="px-5">
						<h6 class="text-h6 mb-0">Color:</h6>
						<div class="d-flex" style="height: 50px">
							<color-picker v-model="localBexLabel.background" />
							<v-spacer />
						</div>
					</div>
				</div>

				<v-divider style="border-color: unset !important"></v-divider>

				<v-card-actions class="mx-5 my-2">
					<v-spacer></v-spacer>
					<v-btn
						text="Cancel"
						variant="text"
						color="error"
						@click="isDialogVisible = false"
					></v-btn>
					<v-btn
						color="primary"
						text="Store"
						variant="flat"
						:disabled="isFormValid === false"
						@click="saveLabel()"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<style lang="scss"></style>
